import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showSuccess, showError } from '../../services/alert';

const SafraForm = () => {
  const { id } = useParams();
  const isEditing = Boolean(id);
  const navigate = useNavigate();

  const [safra, setSafra] = useState({
    descricao: '',
    cultura: '',
    talhaoId: '',
    dataPlantio: '',
    areaHa: 0,
    observacoes: ''
  });
  const [talhoes, setTalhoes] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Carregar lista de talhões
  useEffect(() => {
    api.get("/talhoes")
      .then(res => setTalhoes(res.data || []))
      .catch(err => {
        console.error("Erro ao carregar talhões:", err);
        showError("Erro ao carregar lista de talhões.");
      });
  }, []);

  // 🔹 Carregar safra se edição
  useEffect(() => {
    if (isEditing) {
      setLoading(true);
      api.get(`/safras/${id}`)
        .then(res => {
          const d = res.data;
          setSafra({
            descricao: d.descricao || '',
            cultura: d.cultura,
            talhaoId: d.talhaoId,
            dataPlantio: d.dataPlantio.split('T')[0],
            areaHa: d.areaHa,
            observacoes: d.observacoes || ''
          });
        })
        .catch(() => showError('Erro ao carregar safra.'))
        .finally(() => setLoading(false));
    }
  }, [id, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSafra(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEditing) {
        await api.put(`/safras/${id}`, safra);
        showSuccess('Safra atualizada com sucesso.');
      } else {
        await api.post('/safras', safra);
        showSuccess('Safra criada com sucesso.');
      }
      navigate('/safras');
    } catch {
      showError('Erro ao salvar safra.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex align-items-center gap-3 rounded-top-3">
          <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate('/safras')}
            disabled={loading}
          >
            <i className="bi bi-arrow-left text-success" />
            <span className="text-success fw-semibold">Voltar</span>
          </button>
          <h5 className="mb-0">{isEditing ? 'Editar Safra' : 'Nova Safra'}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Identificação da safra *</label>
              <input
                type="text"
                name="descricao"
                value={safra.descricao}
                onChange={handleChange}
                className="form-control"
                placeholder="Ex.: Safra 2025/2026"
                required
                disabled={loading}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Cultura *</label>
              <input
                type="text"
                name="cultura"
                value={safra.cultura}
                onChange={handleChange}
                className="form-control"
                required
                disabled={loading}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Talhão *</label>
              <select
                name="talhaoId"
                value={safra.talhaoId}
                onChange={handleChange}
                className="form-select"
                required
                disabled={loading}
              >
                <option value="">Selecione...</option>
                {talhoes.map(t => (
                  <option key={t.id} value={t.id}>
                    {t.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Data de Plantio *</label>
              <input
                type="date"
                name="dataPlantio"
                value={safra.dataPlantio}
                onChange={handleChange}
                className="form-control"
                required
                disabled={loading}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Área (ha)</label>
              <input
                type="number"
                name="areaHa"
                value={safra.areaHa}
                onChange={handleChange}
                className="form-control"
                disabled={loading}
              />
            </div>

            <div className="col-12">
              <label className="form-label fw-semibold">Observações</label>
              <textarea
                name="observacoes"
                value={safra.observacoes}
                onChange={handleChange}
                className="form-control"
                disabled={loading}
              />
            </div>

            <div className="col-12 d-flex justify-content-end mt-3">
              <button type="submit" className="btn btn-success me-2 d-flex align-items-center gap-1" disabled={loading}>
                <i className="bi bi-save"></i>
                <span>{loading ? 'Salvando...' : 'Salvar'}</span>
              </button>
              <button
                type="button"
                className="btn btn-secondary d-flex align-items-center gap-1"
                onClick={() => navigate('/safras')}
                disabled={loading}
              >
                <i className="bi bi-x-circle"></i>
                <span>Cancelar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SafraForm;
